import React from "react";
import Grid from '@mui/material/Grid2';
import { TicketNote } from "@services/tickets/types";
import { displayDateTime } from "@common/utils/localTime.utils";
import { IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import ConsoleLog from "@pages/Tickets/ConsoleLog";
import Typography from "@common/components/Typography";
import { Add } from "@mui/icons-material";
import { useContext, useState } from "react";
import AddCommentDialog from "../../AddCommentDialog";
import { FormContext } from "../../context/formContext";

type CommentsProps = {};

const Comments = (props: CommentsProps) => {
  const { t } = useTranslation();
  const { form, canEdit } = useContext(FormContext);
  const { ticket, details } = form;

  const [openAddCommentDialog, setOpenAddCommentDialog] =
    useState<boolean>(false);
  const disabled = ticket?.status == "Closed" || !canEdit;

  const displayCommentsContent = () => {
    return details && details.notes ? (
      details.notes
        .sort(({ createDate: a = 0 }, { createDate: b = 0 }) =>
          Math.sign(b - a)
        )
        .map((comment: TicketNote, index: number) => {
          return (
            <Grid key={`lineComments-${index}`}>
              <Grid container spacing={2} sx={{ width: '100%' }}>
                <Grid>
                  <ConsoleLog>
                    <Typography realTime>
                      {displayDateTime(comment.createDate)}
                    </Typography>
                  </ConsoleLog>
                </Grid>
                <Grid>
                  <Typography realTime>{comment.creator}:</Typography>
                </Grid>
                <Grid
                  sx={{
                    flex: "1"
                  }}>
                  <Typography realTime>{comment.note}</Typography>
                </Grid>
              </Grid>
            </Grid>
          );
        })
    ) : (
      <></>
    );
  };

  return (
    <>
      <Grid
        container
        spacing={2}
        sx={[{
          flexDirection: "column"
        }, (theme) => ({
          padding: theme.spacing(2, 4),
        })]}>
        <Grid>
          <Grid container spacing={2} sx={{ width: '100%', flexDirection: "row" }}>
            <Grid>{t("Comments")}</Grid>
            <Tooltip title={t("Add") as string} arrow>
              <span>
                <IconButton
                  color="primary"
                  size="small"
                  onClick={() => setOpenAddCommentDialog(true)}
                  disabled={disabled}
                  sx={{
                    marginTop: 1.5,
                    marginLeft: 0.75,
                  }}
                >
                  <Add />
                </IconButton>
              </span>
            </Tooltip>
          </Grid>
        </Grid>
        <Grid>
          <Grid container spacing={1} sx={{ width: '100%', flexDirection: "column" }}>
            {displayCommentsContent()}
          </Grid>
        </Grid>
      </Grid>
      <AddCommentDialog
        open={openAddCommentDialog}
        onClose={() => setOpenAddCommentDialog(false)}
      ></AddCommentDialog>
    </>
  );
};

export default Comments;
